var map = {
	"./Van-ministry.jpg": 8437,
	"./av.jpg": 6723,
	"./av.png": 4288,
	"./closet.png": 3023,
	"./culinary.jpg": 3551,
	"./deaconess.jpg": 3972,
	"./deacons.jpg": 9043,
	"./decor.jpg": 72,
	"./evangelism.jpg": 9160,
	"./favicon.png": 6845,
	"./health.jpg": 6793,
	"./heritage.jpg": 8627,
	"./hosp.jpg": 8946,
	"./ministers-wives.jpg": 1141,
	"./ministers.jpg": 6233,
	"./music.jpg": 5003,
	"./music2.png": 7256,
	"./newmember.jpg": 6565,
	"./nursing.jpg": 6823,
	"./office.jpg": 2560,
	"./parking.jpg": 8290,
	"./prison.jpg": 9223,
	"./security.png": 941,
	"./senior_women.jpg": 6179,
	"./shepherds.jpg": 256,
	"./sundayschool.jpg": 2141,
	"./trustee.jpg": 6193,
	"./ushers.jpg": 313,
	"./youth.jpg": 378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9260;